<template>
  <el-dialog width="80%" title="Seleção de usuários" :visible.sync="dialog" append-to-body>
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
      <el-form-item>
        <el-radio-group v-model="ruleForm.type" @change="show">
          <el-radio label="1">Todos</el-radio>
          <el-radio v-if="userType === '1'" label="usersLicense">Por licença</el-radio>
          <el-radio v-if="userType === '1' || userType === '3'" label="usersCustomer">Por cliente</el-radio>
          <el-radio label="usersRole">Por papel</el-radio>
          <el-radio label="tableUsers">Específico</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <MessageAddUsersLicence ref="usersLicense" v-if="ruleForm.type === 'usersLicense'" />
    <MessageAddUsersCustomer :userType="userType" ref="usersCustomer" v-else-if="ruleForm.type === 'usersCustomer'" />
    <MessageAddUsersRole ref="usersRole" v-else-if="ruleForm.type === 'usersRole'" />
    <MessageAddTableUsers ref="tableUsers" v-else-if="ruleForm.type === 'tableUsers'" :search="true" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggle">Cancelar</el-button>
      <el-button type="warning" @click="selected">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
import MessageAddTableUsers from "./MessageAddTableUsers.vue";
import MessageAddUsersCustomer from "./MessageAddUsersCustomer.vue";
import MessageAddUsersLicence from './MessageAddUsersLicence.vue';
import MessageAddUsersRole from "./MessageAddUsersRole.vue";

export default {
  props: ["userType"],
  components: { VueEditor, MessageAddUsersLicence, MessageAddUsersCustomer, MessageAddUsersRole, MessageAddTableUsers },
  data: function () {
    return {
      ruleForm: {
        type: '1',
        to: [],
        subject: '',
        message: "",
      },
      dialog: false,
      users: false,
    };
  },
  methods: {
    show() {
      if (this.ruleForm.type === 'tableUsers') this.$refs.tableUsers.show('', '2')
    },
    open() {
      this.dialog = true;
    },
    toggle() {
      this.dialog = false;
    },
    selected() {
      const vm = this;
      if (vm.ruleForm.type === '1') this.$emit("add", [{ type: 'all', value: 'Todos', label: 'Todos' }]);
      else if (vm.ruleForm.type === 'tableUsers') {
        const userList = this.$refs[vm.ruleForm.type].get();
        if (userList.length === 0) {
          return this.$message.error("Selecione ao menos um usuário");
        }
        this.$emit("add", userList.map(x => {
          return {
            type: 'user',
            value: x.id,
            label: x.name
          }
        }));
      } else {
        this.$emit("add", this.$refs[vm.ruleForm.type].get())
      }
      vm.toggle();
    },

  },
};
</script>